import { creditReason, creditStatus } from "./creditRequestMapping";

const totalCostThreshold = 250;

export function isLineItemAutoApproved(lineItem, creditRequest) {
	const shortSupplyTotalCostInc = creditRequest.lineItems
		.filter((li) => li.reason === creditReason.shortSupply)
		.reduce((total, current) => total + current.lineCostInc, 0);
	return (
		lineItem.reason === creditReason.damagedAndRejected ||
		(lineItem.reason === creditReason.shortSupply && shortSupplyTotalCostInc < totalCostThreshold)
	);
}

export function getLineItemStatusByQuantity(quantity) {
	return quantity === 0 ? creditStatus.cancelled : creditStatus.pendingReview;
}
